export default {"src":"/_next/static/media/shape1.475d2cac.svg","height":116,"width":97};